import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ReportTooltipTemplateContextItem } from '@core/reports-types';

import { ReportTooltipItemComponent } from '../report-tooltip-item/report-tooltip-item.component';

@Component({
  selector: 'reports-tooltip-items-list',
  styleUrls: ['./report-tooltip-items-list.component.less'],
  template: `
    <ng-template #empty>{{ 'tlr.tooltips.empty' | translate }}</ng-template>
    @if (items().length) {
      @for (item of items(); track item.id) {
        <reports-tooltip-item
          [item]="item"
          [fadeOut]="shouldFadeOut() && item.id !== activeId()"
          [wrapValues]="wrapValues()"
        />
      }
    } @else {
      {{ 'tlr.tooltips.empty' | translate }}
    }
  `,
  imports: [TranslatePipe, ReportTooltipItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportTooltipItemsListComponent {
  public items = input.required<ReportTooltipTemplateContextItem[]>();
  public activeId = input<string>();
  public wrapValues = input<boolean>(false);

  public shouldFadeOut = computed(() => {
    const activeId = this.activeId();
    const items = this.items();
    if (items.length === 1 || !activeId) {
      return false;
    }
    return items.some(item => item.id === activeId);
  });
}
